import {
    Box,
    Container,
    Grid,
    Link,
    List,
    ListItem,
    ListItemText,
    Typography,
} from "../../../../../components/ui/LayoutPrimitives";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { getAllProducts } from "../../../api/action/products";
import { getAllProducts } from "../../../../../api/action/products"
//   import SocialIcons from "../../../../assets/SocialIcons";
import SocialIcons from "../../../../../assets/SocialIcons";


const RetailTemplateOneFooter = ({ company }) => {
    const companyState = useSelector((state) => state.companyReducer.company);
    const companyPrimaryId = companyState?.primaryId;
    const companyOperatingLocation = companyState?.operatingLocation?.code;

    const phoneNumber = companyState?.contactPerson?.phoneNumber || "(678) 855-6990";
    const code = companyOperatingLocation || "";

    function assignCountryCode(code) {
        if (code === "US") {
            return "+1";
        }
        if (code === "IND") {
            return "+91";
        } else {
            return "+1";
        }
    }

    const countryCode = assignCountryCode(code);
    // const images = [appstore, googleplay];
    const dispatch = useDispatch();

    const [/*categoryProducts*/, setCategoryProducts] = useState([]);
    const [categories, setCategories] = useState([]);



    useEffect(() => {
        const fetchProducts = async () => {
            if (!companyPrimaryId) return;
            try {
                const response = await getAllProducts(companyPrimaryId)(dispatch);
                setCategoryProducts(response);

                // Extract unique categories from the products
                const uniqueCategories = [
                    ...new Set(response.map((product) => product.category.name)),
                ];

                // Limit to 6 categories
                setCategories(uniqueCategories.slice(0, 6));
            } catch {
                setCategories([]);
            }
        };

        fetchProducts();
    }, [companyPrimaryId, dispatch]);

    // Check if there are categories to display
    const shouldDisplayOnlineShopping = categories.length > 0;

    return (
        <>
            {localStorage.getItem("domainType") !== "ASSESSMENT" ? (
                <Box
                    component="footer"
                    sx={{
                        bgcolor: "#232f3e",
                        color: "white",
                        py: 8,
                        textTransform: "capitalize",
                        mt: 8,
                    }}
                >
                    <Container maxWidth="xl">
                        <Grid container spacing={4}>
                            {shouldDisplayOnlineShopping && (
                                <Grid item xs={12} sm={6} md={3}>
                                    <Box p={3}>
                                        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                                            Online Shopping
                                        </Typography>
                                        <List>
                                            {categories.map((category, index) => (
                                                <ListItem key={index} disableGutters>
                                                    <ListItemText
                                                        primary={
                                                            <Link
                                                                href="#"
                                                                underline="hover"
                                                                sx={{
                                                                    color: "white",
                                                                    "&:hover": { color: "#b0bec5" },
                                                                }}
                                                            >
                                                                {category}
                                                            </Link>
                                                        }
                                                    />
                                                </ListItem>
                                            ))}
                                        </List>
                                    </Box>
                                </Grid>
                            )}
                            <Grid item xs={12} sm={6} md={3}>
                                <Box p={3}>
                                    <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                                        Useful Links
                                    </Typography>
                                    <List>
                                        {[
                                            "Blog",
                                            "Careers",
                                            "Site Map",
                                            "Corporate Information",
                                            "Whitehat",
                                            "Cleartrip",
                                        ].map((text) => (
                                            <ListItem key={text} disableGutters>
                                                <ListItemText
                                                    primary={
                                                        <Link
                                                            href="#"
                                                            underline="hover"
                                                            sx={{
                                                                color: "white",
                                                                "&:hover": { color: "#b0bec5" },
                                                            }}
                                                        >
                                                            {text}
                                                        </Link>
                                                    }
                                                />
                                            </ListItem>
                                        ))}
                                    </List>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <Box p={3}>
                                    <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                                        Customer Policies
                                    </Typography>
                                    <List>
                                        {[
                                            { text: "Terms Of Use", link: "/termsConditions" },
                                            { text: "Privacy Policy", link: "/privacyPolicy" },
                                            { text: "User Acceptance", link: "/userAcceptance" },
                                            { text: "Cookies", link: "/cookies" },
                                            { text: "FAQ", link: "#" },
                                        ].map((item) => (
                                            <ListItem key={item.text} disableGutters>
                                                <ListItemText
                                                    primary={
                                                        <Link
                                                            href={item.link}
                                                            underline="hover"
                                                            sx={{
                                                                color: "white",
                                                                "&:hover": { color: "#b0bec5" },
                                                            }}
                                                        >
                                                            {item.text}
                                                        </Link>
                                                    }
                                                />
                                            </ListItem>
                                        ))}
                                    </List>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <Box p={3}>
                                    <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                                        Keep In Touch
                                    </Typography>
                                    <SocialIcons />
                                    <Typography
                                        variant="body1"
                                        component="div"
                                        sx={{ mt: 1, display: "flex", alignItems: "center" }}
                                    >
                                        <Link
                                            href={"tel:" + phoneNumber}
                                            underline="hover"
                                            sx={{
                                                color: "white",
                                                "&:hover": { color: "#b0bec5" },
                                            }}
                                        >
                                            {countryCode} {phoneNumber}
                                        </Link>
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                ml: 1,
                                                color: "white",
                                                "&:hover": { color: "#b0bec5" },
                                            }}
                                        >
                                            {company?.contactPerson?.email || "system@avpstech.com"}
                                        </Typography>
                                    </Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    </Container>
                </Box>
            ) : null}
        </>
    );
};

export default RetailTemplateOneFooter;
